"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUseMethodSerializer = exports.UseMethod = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var UseMethod;
(function (UseMethod) {
    UseMethod[UseMethod["Burn"] = 0] = "Burn";
    UseMethod[UseMethod["Multiple"] = 1] = "Multiple";
    UseMethod[UseMethod["Single"] = 2] = "Single";
})(UseMethod = exports.UseMethod || (exports.UseMethod = {}));
function getUseMethodSerializer() {
    return (0, serializers_1.scalarEnum)(UseMethod, {
        description: 'UseMethod',
    });
}
exports.getUseMethodSerializer = getUseMethodSerializer;
//# sourceMappingURL=useMethod.js.map